import { Resource as Model } from 'model';
import React from 'react';
import { searchResources } from 'components/SearchUtils';
import { ManPage } from 'components/ManPage/ManPage';

export class Resources extends React.Component<{ resources: Model[] }, { items: Model[] }> {
  constructor(props: { resources: Model[] }) {
    super(props);
    this.state = { items: props.resources };
  }

  onTextChange(text: string): void {
    const trimmed = text.trim();
    const items = trimmed === '' ? this.props.resources : searchResources(this.props.resources, trimmed);
    this.setState({ items });
  }

  render(): JSX.Element {
    return (
      <ManPage
        name="resources"
        manual="Links & References"
        sections={[
          { heading: 'NAME', body: 'resources - links, tools, references' },
          {
            heading: 'SEARCH',
            body: (
              <input
                type="text"
                className="man-input"
                placeholder="grep..."
                onChange={(e) => this.onTextChange(e.target.value)}
              />
            )
          },
          {
            heading: 'ENTRIES',
            body: (
              <>
                {this.state.items.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 16 }}>
                    <div className="man-sub">
                      <a href={item.url} target="_blank" rel="noreferrer">
                        {item.title}
                      </a>
                    </div>
                    <div>{item.description}</div>
                    <div>[{item.tags.join(', ')}]</div>
                  </div>
                ))}
              </>
            )
          }
        ]}
      />
    );
  }
}
